ACC.refinements = {

  bindAll: function() {
    this.bindRefinementCategoryToggles();
    this.bindMoreLessToggles();
    this.bindMoreStoresToggles();
  },

  bindRefinementCategoryToggles: function() {
    $('a.refinementToggle').each(function() {
      $(this).attr('title', $(this).data('hideFacetText'));

      $(this).on('click', function() {
        var content = $(this).parents('.facet').find('div.facetValues');

        /* eslint-disable no-ternary */
        $(this).attr('title', $(content).is(':visible') ? $(this).data('showFacetText') : $(this).data('hideFacetText'));
        /* eslint-enable no-ternary */
        $(this).toggleClass('close');
        $(content).slideToggle();

        return false;
      });

      $(this).next().click(function() {
        $(this).prev().click();
      });
    });
  },

  bindMoreLessToggles: function() {
    $('a.moreFacetValues').click(function(event) {
      var eParent = $(this).parents('.facetValues');

      event.preventDefault();
      eParent.find('.topFacetValues').hide();
      eParent.find('.allFacetValues').show();
    });

    $('a.lessFacetValues').click(function(event) {
      var eParent = $(this).parents('.facetValues');

      event.preventDefault();
      eParent.find('.topFacetValues').show();
      eParent.find('.allFacetValues').hide();
    });
  },

  bindMoreStoresToggles: function() {
    $('a.moreStoresFacetValues').click(function(event) {
      event.preventDefault();

      $(this).parents('div.allFacetValues').find('li.hidden').slice(0, 5).removeClass('hidden').first().find('input:[type=checkbox]').focus();
    });
  }
};

$(document).ready(function() {
  ACC.refinements.bindAll();
});
